import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setAllAttendeesRegistrationFilter } from '@/store/slices/audiences';
import { selectAllAttendeesRegistrationFilter } from '@/store/slices/audiences/selectors';
import type { RegistrationFilter } from '@/types/all-attendees.types';
import Popover from '@ui/popover/popover';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { Activity } from 'react';
import styles from './profiles-registration-status-filter.module.css';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';
import Button from '@ui/buttons/button/button';

type FilterOption = {
  label: string;
  value: RegistrationFilter;
};

const OPTIONS: FilterOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Registered', value: 'registered' },
  { label: 'Invited', value: 'invited' },
  { label: 'Added', value: 'added' },
];

const ProfilesRegistrationStatusFilter = () => {
  const dispatch = useAppDispatch();
  const current = useAppSelector(selectAllAttendeesRegistrationFilter);
  const currentLabel = OPTIONS.find((o) => o.value === current)?.label ?? 'All';
  return (
    <Popover
      id="profiles-registration-status-filter"
      preferredPosition="bottom-left"
      width="160px"
      renderTriggerButton={({ open, closing }) => (
        <Container className={`flex ai-center gap-8 ${styles.trigger} ${open ? styles.open : ''}`} height="32px">
          <Text className="P2" whiteSpace="nowrap" design="GlobalIcoText3">
            Registration Status:
          </Text>
          <Text className="P2" whiteSpace="nowrap" design="GlobalIcoText1">
            {currentLabel}
          </Text>
          <RotatableIcon
            name={ICONS.KEYBOARD_ARROW_DOWN}
            size={12}
            color="currentColor"
            rotate={open && !closing ? '180deg' : '0'}
          />
        </Container>
      )}
    >
      {({ handleClose }) => (
        <Container className="flex fd-column">
          {OPTIONS.map((option) => (
            <Button
              key={option.value}
              style={{ cursor: 'pointer' }}
              className="no-style flex ai-center padding-h-16 padding-v-8"
              onClick={() => {
                dispatch(setAllAttendeesRegistrationFilter(option.value));
                handleClose();
              }}
            >
              <Container className="flex ai-center jc-space-between" width="100%">
                <Text className="P2" design="GlobalIcoText1">
                  {option.label}
                </Text>
                <Activity mode={current === option.value ? 'visible' : 'hidden'}>
                  <Icon name={ICONS.CHECK} size={12} color="var(--global-ico-text-1)" />
                </Activity>
              </Container>
            </Button>
          ))}
        </Container>
      )}
    </Popover>
  );
};

export default ProfilesRegistrationStatusFilter;
